import { NOTIFY_ABOUT_ERROR } from '../actions/sentry';

const initialState = {
  serverRejection: {},
  serverFetch: {},
  serverReferenceError: '',
  clientRejection: {},
  clientReferenceError: '',
};

const ACTIONS = {
  [NOTIFY_ABOUT_ERROR]: ({ state, action }) => ({ ...state, [action.field]: action.error }),
};

export default function sentry(state = initialState, action) {
  return ACTIONS[action.type] ? ACTIONS[action.type]({ state, action }) : state;
}
